import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  /* display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem; */

  display: flex;
`;

export const Stack = styled.p`
  font-size: 14px;
  font-weight: 300;
`;

export const Description = styled.div`
  h3 {
    margin: 0;
  }
  Button {
    margin-right: 1rem;
    padding: 0.5rem 1rem;
  }
  .justified{
    text-align: justify;
  }
`;
